import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
export default {
  name: "bnb-user",
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        user_type_status: 0,
        // 0:全部，1:待认证，2:认证中, 3:已认证
        user_type_account_status: "",
        phone: "",
        name: "",
        remark: ""
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 总数

      authNotCount: 0,
      // 待认证
      authProcessCount: 0,
      // 认证中
      authSuccessCount: 0,
      // 已认证
      oweCount: 0,
      // 欠费人数

      currentRow: {},
      // 当前行
      remarkDialogVisible: false,
      // 备注弹窗
      amount: "",
      // 充值金额
      topUpDialogVisible: false // 充值弹窗
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    // 退款
    bnbAccountRefund: function bnbAccountRefund(row) {
      var _this2 = this;
      this.$confirm("退款", "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.bnbAccountRefund({
                user_id: row.id
              });
            case 1:
              _this2.getData();
              _this2.$message.success("操作成功");
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      })));
    },
    // 通过认证 | 拒绝认证
    setUserTypeStatus: function setUserTypeStatus(row, status) {
      var _this3 = this;
      this.$confirm("民宿认证", "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$api.setUserTypeStatus({
                user_id: row.id,
                user_type_status: status
              });
            case 1:
              _this3.getData();
              _this3.$message.success("操作成功");
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      })));
    },
    // 充值
    bnbAccountCharge: function bnbAccountCharge() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this4.$api.bnbAccountCharge({
                user_id: _this4.currentRow.id,
                amount: _this4.amount
              });
            case 1:
              _this4.$message.success("充值成功");
              _this4.getData();
              _this4.amount = "";
              _this4.topUpDialogVisible = false;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (type === "search") {
                _this5.searchForm.pn = 1;
              }
              _this5.tableLoading = true;
              _context5.n = 1;
              return _this5.$api.getBnbUserList(_this5.searchForm);
            case 1:
              res = _context5.v;
              _this5.tableData = res.data.list;
              _this5.total = res.data.count;
              _this5.authNotCount = res.data.auth_not_count;
              _this5.authProcessCount = res.data.auth_process_count;
              _this5.authSuccessCount = res.data.auth_success_count;
              _this5.oweCount = res.data.owe_count;
              _this5.tableLoading = false;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    }
  }
};